import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router'
import { Injectable } from '@angular/core'
import { switchMap, tap } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { VerticalService } from 'src/app/singleton-services/vertical.service'
import { PlatformService } from 'src/app/singleton-services/platform.service'
import { ServerResponseService } from '../services/server-response.service'
@Injectable()
export class RankingsGuard implements CanActivate {
  constructor(
    private readonly verticalService: VerticalService,
    private readonly serverResponseService: ServerResponseService,
    private readonly platformService: PlatformService, 
    private readonly router: Router
  ) {}

  canActivate(ars: ActivatedRouteSnapshot): Observable<boolean> {
    return this.verticalService.isVarsity$.pipe(
      switchMap(isVarsity => {
        const relativeURL = '/standings'
        let queryParams: string = ''

        if (ars.queryParamMap.keys) {
          // Setting query params
          queryParams = ars.queryParamMap.keys.reduce((prev, curr) => {
            const qp = `${curr}=${ars.queryParamMap.get(curr)}`
            return prev === '?' ? `${prev}${qp}` : `${prev}&${qp}`
          }, '?')
        }

        const redirectUrlWithQueryParams = queryParams.length > 1 ? `${relativeURL}${queryParams}` : relativeURL
        // Server-Side Renders get a 301 redirect
        if (this.platformService.isServer && isVarsity) {
          return of(false).pipe(tap(() => this.serverResponseService.redirect(redirectUrlWithQueryParams, 301)))
        }

        return isVarsity ? of(false).pipe(tap(() => this.router.navigateByUrl(redirectUrlWithQueryParams))) : of(true)
      })
    )
  }
}
